import { render, staticRenderFns } from "./courseClassificationManagement.vue?vue&type=template&id=42219cf1&scoped=true&"
import script from "./courseClassificationManagement.vue?vue&type=script&lang=js&"
export * from "./courseClassificationManagement.vue?vue&type=script&lang=js&"
import style0 from "./courseClassificationManagement.vue?vue&type=style&index=0&id=42219cf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42219cf1",
  null
  
)

export default component.exports